import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { ArrowUpRight, Search } from "lucide-react";

export default function PackagesList() {
  const [q, setQ] = useState("");
  const { data: packages = [] } = useQuery({
    queryKey: ["packages-list", q],
    queryFn: () => api.get("/packages", { params: { is_active: true, search: q || undefined, limit: 60 } }).then((r) => r.data.items),
  });
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Tour Packages</div>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">Signature journeys.</h1>
          <div className="relative w-full max-w-sm">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search packages…" className="pl-9" data-testid="packages-search" />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p) => (
            <Link to={`/packages/${p.slug}`} key={p.id} className="group rounded-2xl overflow-hidden border border-slate-200 bg-white hover:-translate-y-1 transition-transform" data-testid={`pkg-${p.slug}`}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={p.banner_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-3 left-3 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-xs font-medium">{p.duration_days}D · {p.duration_nights}N</div>
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-[0.2em] text-amber-600">{p.destination}</div>
                <div className="mt-2 font-display text-2xl text-slate-950 group-hover:text-amber-700">{p.name}</div>
                <p className="text-slate-600 text-sm mt-2 line-clamp-2">{p.overview}</p>
                <div className="mt-5 flex items-center justify-between">
                  <div className="text-sm text-slate-500">From <span className="text-slate-950 font-medium">₹{p.price_from?.toLocaleString?.("en-IN")}</span></div>
                  <span className="text-sm text-slate-700 flex items-center gap-1">Explore <ArrowUpRight className="w-4 h-4" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        {packages.length === 0 && (
          <div className="mt-16 text-center text-slate-500">No packages match your search.</div>
        )}
      </div>
    </div>
  );
}
